import React, { useState, useEffect } from 'react';
import CustomerLayout from '../components/CustomerLayout';
import { customerAPI } from '../lib/api';
import '../App.css';

export default function Assets() {
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchAssets();
    }, []);

    const fetchAssets = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await customerAPI.getAssets();
            setAssets(response.data.assets || []);
        } catch (err) {
            console.error('Error fetching assets:', err);
            setError(err.response?.data?.error || 'Failed to load assets');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-AU');
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'active': return '#28a745';
            case 'inactive': return '#6c757d';
            case 'maintenance': return '#ffc107';
            default: return '#007bff';
        }
    };

    return (
        <CustomerLayout>
            <div style={{ maxWidth: '1200px' }}>
                <h1 style={{ marginBottom: '10px' }}>Assets</h1>
                <p style={{ color: '#666', marginBottom: '30px' }}>View your equipment, licenses, and other assets</p>

                {error && (
                    <div className="alert alert-error">{error}</div>
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '60px' }}>
                        <div className="spinner"></div>
                        <p style={{ marginTop: '20px', color: '#666' }}>Loading assets...</p>
                    </div>
                ) : assets.length === 0 ? (
                    <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
                        <p style={{ fontSize: '18px', color: '#666' }}>No assets found</p>
                    </div>
                ) : (
                    <div className="card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Asset Name</th>
                                    <th>Type</th>
                                    <th>Serial Number</th>
                                    <th>Location</th>
                                    <th>Purchase Date</th>
                                    <th>Warranty Expiry</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assets.map((asset) => (
                                    <tr key={asset.asset_id}>
                                        <td><strong>{asset.asset_name}</strong></td>
                                        <td>{asset.asset_type}</td>
                                        <td>{asset.serial_number || 'N/A'}</td>
                                        <td>{asset.location || 'N/A'}</td>
                                        <td>{formatDate(asset.purchase_date)}</td>
                                        <td>{formatDate(asset.warranty_expiry)}</td>
                                        <td>
                                            <span
                                                className="status-badge"
                                                style={{ backgroundColor: getStatusColor(asset.status), color: 'white' }}
                                            >
                                                {asset.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </CustomerLayout>
    );
}
